import React, { useState, useEffect } from "react";
import axios from "axios";
import "../App.css";

import { acceptReport, rejectReport, adminUpdateUserProfile, getUserById } from "../services/reactapis";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ApiUrl } from '../Constants/Weburl'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import Layout from '../components/Layout';
import CustomCard from "../components/Customsettingscard";
import CustomButton from "../components/CustomButton";
import "../CssPage/Livesettings.css";
import PhoneInput from "react-country-phone-input";
import "react-country-phone-input/lib/style.css";


export default function Editprofile() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [bio, setBio] = useState("");

    const [dialCode, setDialCode] = useState("91");
    const [countryIso, setCountryIso] = useState("in");
    const [phone, setPhone] = useState("");

    const [currentAvatar, setCurrentAvatar] = useState("");
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState("");

    const [loadingUser, setLoadingUser] = useState(true);
    const [saving, setSaving] = useState(false);

    // ── User data load ──
    useEffect(() => {
        const loadUser = async () => {
            try {
                setLoadingUser(true);
                const token = localStorage.getItem("adminToken");

                const res = await getUserById(token, id);
                console.log("EDIT PROFILE USER:", res);

                if (res?.success) {
                    const user = res.data;
                    const dial = String(user.phoneCode || "91").replace("+", "");

                    setName(user.name || "");
                    setUsername(user.username || "");
                    setEmail(user.email || "");
                    setBio(user.bio || "");
                    setCurrentAvatar(user.avatar || "");
                    setDialCode(dial);
                    setCountryIso(String(user.countryCode || "IN").toLowerCase());
                    setPhone(`${dial}${user.phone || ""}`);
                }
            } catch (error) {
                console.error("Load user error:", error?.response?.data || error);
                alert(error?.response?.data?.message || "Failed to load user");
            } finally {
                setLoadingUser(false);
            }
        };

        loadUser();
    }, [id]);

    useEffect(() => {
        if (!avatarFile) {
            setAvatarPreview("");
            return;
        }
        const url = URL.createObjectURL(avatarFile);
        setAvatarPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [avatarFile]);

    // ── Save ──
    const handleSave = async () => {
        if (!username.trim() || !email.trim()) {
            alert("Username and Email are required");
            return;
        }

        try {
            setSaving(true);
            const token = localStorage.getItem("adminToken");

            const formData = new FormData();
            formData.append("name", name);
            formData.append("username", username);
            formData.append("email", email);
            formData.append("bio", bio);
            formData.append("phone", phone.slice(dialCode.length));
            formData.append("phoneCode", `+${dialCode}`);
            formData.append("countryCode", countryIso.toUpperCase());
            if (avatarFile) formData.append("avatar", avatarFile);

            const res = await adminUpdateUserProfile(token, id, formData);

            if (res?.success) {
                alert("Profile updated successfully");
                navigate(-1);
            }
        } catch (error) {
            console.error("Update profile error:", error?.response?.data || error);
            alert(error?.response?.data?.message || "Failed to update profile");
        } finally {
            setSaving(false);
        }
    };

    const shownAvatar = avatarPreview || currentAvatar;

    return (
        <div className="layout">
            <Layout>
                <CustomContainer className="rr-wrapper rr-wrapper-editprofile" fluid="false">
                    <div className="rr-card">
                        <div className="ls-section-title">Edit Profile</div>

                        {loadingUser ? (
                            <div style={{ padding: 20 }}>Loading...</div>
                        ) : (
                            <>
                                <div className="profile-pill">
                                    {shownAvatar && (
                                        <div className="avatar">
                                            <img
                                                src={shownAvatar}
                                                alt=""
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div>
                                        <div className="username">{username}</div>
                                        <div className="subtext">{name}</div>
                                    </div>
                                </div>

                                <div className="rr-card">

                                    <div className="ls-grid-3">
                                        <CustomCard className="ls-card">
                                            <CustomInput
                                                label="Profile Photo"
                                                labelClassName="ls-label"
                                                type="file"
                                                accept="image/*"
                                                className="ls-input"
                                                onChange={(e) => setAvatarFile(e.target.files[0] || null)}
                                            />
                                        </CustomCard>

                                        <CustomCard className="ls-card">
                                            <CustomInput
                                                label="Fullname"
                                                labelClassName="ls-label"
                                                type="text"
                                                className="ls-input"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </CustomCard>

                                        <CustomCard className="ls-card">
                                            <CustomInput
                                                label="Username"
                                                labelClassName="ls-label"
                                                type="text"
                                                className="ls-input"
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                        </CustomCard>

                                        <CustomCard className="ls-card">
                                            <CustomInput
                                                label="Email"
                                                labelClassName="ls-label"
                                                type="email"
                                                className="ls-input"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </CustomCard>

                                        <CustomCard className="ls-card phone-card">
                                            <label className="ls-label">Mobile</label>
                                            <PhoneInput
                                                country={countryIso}
                                                preferredCountries={["in", "us", "gb", "ae"]}
                                                value={phone}
                                                onChange={(value, country) => {
                                                    setPhone(value);
                                                    setDialCode(country.dialCode);
                                                    setCountryIso(country.countryCode);
                                                }}
                                                enableSearch
                                                containerClass="ls-phone"
                                                inputStyle={{ width: "100%" }}
                                            />
                                        </CustomCard>

                                        {/* <CustomCard className="ls-card">
                                        <CustomInput
                                            label="Bio"
                                            labelClassName="ls-label"
                                            type="text"
                                            className="ls-input"
                                            value={bio}
                                            onChange={(e) => setBio(e.target.value)}
                                        />
                                    </CustomCard> */}

                                        <CustomCard className="ls-card">
                                            <label className="ls-label">Bio</label>

                                            <textarea
                                                className="ls-input bio-textarea"
                                                value={bio}
                                                onChange={(e) => setBio(e.target.value)}
                                                rows={4}
                                                placeholder="Enter bio"
                                            />
                                        </CustomCard>
                                    </div>

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: 12,
                                        marginTop: 20,
                                    }}
                                >
                                    <CustomButton variant="secondary" onClick={() => navigate(-1)}>
                                        Cancel
                                    </CustomButton>
                                    <CustomButton
                                        variant="dark"
                                        onClick={handleSave}
                                        disabled={saving}
                                    >
                                        {saving ? "Saving..." : "Save Changes"}
                                    </CustomButton>
                                </div>
                            </>
                        )}
                    </div>
                </CustomContainer>
            </Layout>
        </div>
    );
}